export default __webpack_public_path__ + "static/media/skiJacket.459ee0ca.svg";